// extracted by mini-css-extract-plugin
export default {"item":"ProductItem_item__44Scb","productItem":"ProductItem_productItem__QN1Vh","description":"ProductItem_description__Z0moN","cartBtn":"ProductItem_cartBtn__qI08C"};